export default __webpack_public_path__ + "static/media/cmercury-png.de9782dc.png";